import { jsxs as o, jsx as l } from "react/jsx-runtime";
import { getIconStyles as n } from "../styles.js";
const t = (e) => /* @__PURE__ */ o(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: n(e),
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.46967 20.1904C3.17678 19.8975 3.17678 19.4226 3.46967 19.1297L19.3797 3.21973C19.6726 2.92684 20.1474 2.92684 20.4403 3.21973C20.7332 3.51263 20.7332 3.9875 20.4403 4.2804L4.53033 20.1904C4.23744 20.4833 3.76256 20.4833 3.46967 20.1904Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.16 3.74991C4.16 3.3357 4.49579 2.99991 4.91 2.99991L19.91 2.99991C20.3242 2.99991 20.66 3.3357 20.66 3.74991V18.7499C20.66 19.1641 20.3242 19.4999 19.91 19.4999C19.4958 19.4999 19.16 19.1641 19.16 18.7499L19.16 4.49991L4.91 4.49991C4.49579 4.49991 4.16 4.16412 4.16 3.74991Z",
          fill: "currentColor"
        }
      )
    ]
  }
);
export {
  t as ArrowPointingUpIcon
};
//# sourceMappingURL=ArrowPointingUpIcon.js.map
